// noinspection DuplicatedCode

import TaxPayer from "app/pages/taxPayers/models/TaxPayer";
import { withStatus, withTimesTamps } from "app/pages/receipts/models/commons";
import { formatCurrency } from "cofa/utils/functions/text";

class DailyObstructionDepositReceipt {
  paymentMode;

  ref;
  code;
  amount;
  paymentDate;
  agentId;
  agentName;
  agentDepositDate;
  agentDepositRef;
  cashierId;
  cashierName;
  cashierDepositDate;
  status;
  canceled;
  canceledAt;
  canceledBy;
  cancelReason;
  canceledByName;
  longitude;
  latitude;
  taxPayer;

  searchSlug;

  constructor(receipt) {
    Object.assign(this, receipt);
  }

  static fromJson(receipt) {
    return new DailyObstructionDepositReceipt({
      ref: receipt["ref"],

      code: receipt["code"],

      amount: receipt["amount"],
      paymentDate: receipt["payment_date"],

      agentId: receipt["agent_id"],
      agentName: receipt["agent_name"],
      agentDepositDate: receipt["agent_deposit_date"],
      agentDepositRef: receipt["agent_deposit_ref"],

      deposed: !!receipt["agent_deposit_date"],
      collected: !!receipt["agent_deposit_date"],

      cashierId: receipt["cashier_id"],
      cashierName: receipt["cashier_name"],
      cashierDepositDate: receipt["cashier_deposit_date"],

      canceled: !!receipt["canceled_at"],
      notCanceled: !receipt["canceled_at"],
      canceledAt: receipt["canceled_at"],
      cancelReason: receipt["cancel_reason"],
      canceledBy: receipt["canceled_by_id"],
      canceledByName: receipt["canceled_by_name"],

      longitude: receipt["longitude"],
      latitude: receipt["latitude"],

      taxPayer: receipt["tax_payer"] && TaxPayer.fromJson(receipt["tax_payer"]),

      ...withTimesTamps(receipt),
      ...withStatus(receipt),
    });
  }

  getLabelFr(modes) {
    return (
      modes.find((mode) => mode.code === this.paymentMode)?.label ??
      this.paymentMode
    );
  }

  getSearchSlug(additionalValues = []) {
    return [
      ...additionalValues,
      this.ref,
      this.code,
      this.taxPayer?.ref,
      this.taxPayer?.address,
      this.taxPayer?.phone,
      this.taxPayer?.nif,
      this.taxPayer?.address,
      this.taxPayer?.firstName,
      this.taxPayer?.lastName,
      this.amount,
      formatCurrency(this.amount),
      this.paymentMode,
      this.agentId,
      this.cashierId,
      this.agentName,
      this.cashierName,
      this.status,
      this.agentDepositRef,
      this.canceled,
      this.canceledAt,
      this.canceledBy,
      this.cancelReason,
      this.canceledByName,
    ].join("");
  }

  populateWithData({ paymentModes = [] }) {
    //Translate Payment mode to French.
    this.paymentModeFr = this.getLabelFr(paymentModes);

    //Generate search slug that easier search.
    this.searchSlug = this.getSearchSlug([this.paymentModeFr]);

    //Use this method in fluent mode.
    return this;
  }

  asCanceled() {
    this.amount = -1 * this.amount;
    this.canceled = true;

    return this;
  }

  removeCanceledState() {
    this.canceled = false;

    this.canceledAt = null;
    this.canceledBy = null;
    this.canceledByName = null;
    this.cancelReason = null;

    return this;
  }
}

export default DailyObstructionDepositReceipt;
